export function promiseAllSettled(values) {
    return Promise.all(values.map(p => 
    // eslint-disable-next-line github/no-then
    Promise.resolve(p).then((value) => ({ status: 'fulfilled', value }), (reason) => ({ status: 'rejected', reason }))));
}
/*#__PURE__*/
export function isSupported() {
    return 'allSettled' in Promise && typeof Promise.allSettled === 'function';
}
/*#__PURE__*/
export function isPolyfilled() {
    return Promise.all === promiseAllSettled;
}
export function apply() {
    if (!isSupported()) {
        Promise.allSettled = promiseAllSettled;
    }
}
//# sourceMappingURL=promise-allsettled.js.map